import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppUsageChartComponent } from './components/app-usage-chart/app-usage-chart.component';
import { CheckinRatioChartComponent } from './components/checkin-ratio-chart/checkin-ratio-chart.component';
import { CleaningRequestsChartComponent } from './components/cleaning-requests-chart/cleaning-requests-chart.component';
import { CleaningSchedulesChartComponent } from './components/cleaning-schedules-chart/cleaning-schedules-chart.component';
import { IssueOverviewComponent } from './components/issue-overview/issue-overview.component';
import { OccupiedFlatsChartComponent } from './components/occupied-flats-chart/occupied-flats-chart.component';
import { ParkingUtilizationChartComponent } from './components/parking-utilization-chart/parking-utilization-chart.component';
import { StartingBookingsChartComponent } from './components/starting-bookings-chart/starting-bookings-chart.component';
import { TodaysMetricsComponent } from './components/todays-metrics/todays-metrics.component';

@Component({
  selector: 'app-overview-st',
  imports: [
    CommonModule,
    TranslateModule,
    TodaysMetricsComponent,
    IssueOverviewComponent,
    CheckinRatioChartComponent,
    AppUsageChartComponent,
    StartingBookingsChartComponent,
    OccupiedFlatsChartComponent,
    ParkingUtilizationChartComponent,
    CleaningRequestsChartComponent,
    CleaningSchedulesChartComponent
  ],
  templateUrl: './overview-st.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewStComponent {}
